<template>
 <div>

     <Row><Button style="float: right; margin:-5px 0 6px 0" @click="onAddContractor">Add Contractor</Button></Row>
     <Table :columns="contractorHeaders" :data="contractorArr" size="small" stripe @on-row-click=""  max-height="700">
         <template slot-scope="{ row }" slot="action">
             <Icon type="md-create" @click="onEditContractor(row)"></Icon>&nbsp;
             <Icon type="md-close" @click="onDeleteContractor(row.id)"></Icon>
         </template>
         <template slot-scope="{ row }" slot="addFunctionality">
             <Tooltip content="Add Driver" placement="bottom">
             <Button @click.stop="onAddDriver(row)" style="font-weight: bolder;margin-right: 10px">Driver
                 <i class="fas fa-user-plus" style="margin: 0 -8px 0 8px;font-size: 12px"></i></Button>
             </Tooltip>
             <Tooltip content="Add Tempo" placement="bottom">
             <Button @click.stop="onAddTempo(row)" style="font-weight: bolder">Tempo
                 <i class="fas fa-truck-pickup" style="margin: 0 -8px 0 8px;font-size: 12px"></i></Button>
             </Tooltip>
         </template>
     </Table>

     <driver ref="driver-comp" isLoadedIn="contractors"></driver>
     <tempo ref="tempo-comp"></tempo>

   <add-contractor ref="contractor-form"></add-contractor>

 </div>
</template>

<script>
import {ADD_CONTRACTOR, UPDATE_CONTRACTOR, DELETE_CONTRACTOR} from '../graphql/mutations/vehicle'
import { GET_CONTRACTORS, GET_LAST_CONTRACTOR} from '../graphql/queries/vehicle'
import { SUBSCRIBE_CONTRACTORS} from '../graphql/subscription/vehicle'
import Driver from './Settings/Driver'
import Tempo from './Settings/Tempo'
import AddContractor from "./ExcelContractors/AddContractor";
    export default {
        apollo: {
            contractor: {
                query: GET_CONTRACTORS,
                subscribeToMore: {
                    document: SUBSCRIBE_CONTRACTORS,
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.contractorArr = subscriptionData.data.contractor;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.contractorArr = data.contractor;
                    }
                }
            },
        },
        name: "Contractors",
        components:{AddContractor, Driver, Tempo},
        data: function(){
            return{
                mutation_ADD_CONTRACTOR: ADD_CONTRACTOR,
                mutation_UPDATE_CONTRACTOR: UPDATE_CONTRACTOR,
                mutation_DELETE_CONTRACTOR: DELETE_CONTRACTOR,
                query_GET_LAST_CONTRACTOR: GET_LAST_CONTRACTOR,
                contractorArr: [],
                contractorHeaders: [
                    {title: 'Name', key: 'name', width:200},
                    {title: 'Code', key: 'contractorCode', width:80},
                    {title: 'Mobile', key: 'mobile', width:130},
                    {title: 'Email', key: 'email'},
                    {title: 'Monthly KM', key: 'monthlyKms', width:100,
                        renderHeader: function (h) {return h('div', [h('p', 'Monthly'), h('p', 'KM')])}},
                    {title: ' ', slot: 'addFunctionality'},
                    {title: 'Action', slot: 'action', width: 100}
                ],
                loading: false
            }
        },
        methods:{
            onAddContractor(){
              this.$refs['contractor-form'].onAddContractor();
            },
            onEditContractor(row){
              this.$refs['contractor-form'].onEditContractor(row);
            },
            onDeleteContractor(contractorId){
                this.$Modal.confirm({
                    title: 'Confirmation',
                    content: '<p>Are You sure want to delete Contractor ?</p>',
                    loading: true,
                    onOk: () => {
                        this.deleteContractor(contractorId, this.$Modal)
                    }
                });
            },
            deleteContractor(contractorId, callback){
                this.$apollo.mutate({
                    mutation: this.mutation_DELETE_CONTRACTOR,
                    variables: { contractorId: contractorId }
                }).then(function(response){
                    callback.remove();
                    this.$Message.success('Contractor deleted successfully!');
                }).catch(function(err){
                    callback.remove();
                })
            },
            onAddDriver(row){
                this.$refs['driver-comp'].onAddDriver(row)
            },
            onAddTempo(row){
                this.$refs['tempo-comp'].onAddTempo(row)
            }
        },
    }
</script>

<style scoped>

</style>
